"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudProvider = exports.ZodIceTransportRequestOptions = exports.ZodTurnProtocolOptions = exports.TrafficAccelerator = exports.VideoSpatialLayer = exports.ZodTransportDirection = exports.SFULoadMetric = exports.isConsumerKind = exports.ZodConsumerKind = exports.ConsumerKindEnum = void 0;
const zod = __importStar(require("zod"));
exports.ConsumerKindEnum = ["audio", "video", "screen", "sound"];
exports.ZodConsumerKind = zod.enum(exports.ConsumerKindEnum);
const isConsumerKind = (kind) => exports.ConsumerKindEnum.map((k) => k.toString()).includes(kind);
exports.isConsumerKind = isConsumerKind;
var SFULoadMetric;
(function (SFULoadMetric) {
    SFULoadMetric["Cpu"] = "cpu";
    SFULoadMetric["Bandwidth"] = "bandwidth";
})(SFULoadMetric || (exports.SFULoadMetric = SFULoadMetric = {}));
exports.ZodTransportDirection = zod.union([zod.literal("send"), zod.literal("recv")]);
var VideoSpatialLayer;
(function (VideoSpatialLayer) {
    VideoSpatialLayer[VideoSpatialLayer["LowQuality"] = 0] = "LowQuality";
    VideoSpatialLayer[VideoSpatialLayer["MidQuality"] = 1] = "MidQuality";
    VideoSpatialLayer[VideoSpatialLayer["HighQuality"] = 2] = "HighQuality";
})(VideoSpatialLayer || (exports.VideoSpatialLayer = VideoSpatialLayer = {}));
var TrafficAccelerator;
(function (TrafficAccelerator) {
    TrafficAccelerator["None"] = "None";
    TrafficAccelerator["Spectrum"] = "Spectrum";
    TrafficAccelerator["GlobalAccelerator"] = "GlobalAccelerator";
})(TrafficAccelerator || (exports.TrafficAccelerator = TrafficAccelerator = {}));
exports.ZodTurnProtocolOptions = zod.union([zod.literal("udp"), zod.literal("tcp")]);
exports.ZodIceTransportRequestOptions = zod.object({
    forceProtocol: exports.ZodTurnProtocolOptions.optional(),
    forceTurn: zod.boolean().optional(),
    trafficAccelerator: zod.nativeEnum(TrafficAccelerator).optional(),
    cloudflareTurn: zod.boolean().optional(),
    preferCloudflareTurn: zod.boolean().optional(),
});
var CloudProvider;
(function (CloudProvider) {
    CloudProvider[CloudProvider["DigitalOcean"] = 0] = "DigitalOcean";
    CloudProvider[CloudProvider["Aws"] = 1] = "Aws";
    CloudProvider[CloudProvider["Gcp"] = 2] = "Gcp";
})(CloudProvider || (exports.CloudProvider = CloudProvider = {}));
//# sourceMappingURL=common.js.map